<div class="showroom">
  <div class="showroom__content h-100 d-flex">
    <div *ngIf="categoryDetails && !activeSelectedType" class="tablet-content options-electro__tablet-top-sub-content">
      <ng-container *ngTemplateOutlet="categoryDetailsTemplate"></ng-container>
    </div>
    <div *ngIf="categoryDetails && activeSelectedType" class="tablet-content options-electro__tablet-top-sub-content desctop-view">
      <div class="product-type-header" [ngClass]="activeSelectedType.description ? 'mb-24' : 'no-data'">
        <ng-container
          *ngTemplateOutlet="productTypeSubHeaderTemplate; context: { type: activeSelectedType }"></ng-container>
      </div>

    </div>
    <div class="showroom__column sticky-el sticky-second"
         [ngClass]="{'active-type': activeSelectedType }">
      <div class="showroom__left-content h-100 v-scrollbar" >
        <ng-container *ngIf="contentLoaded; else spinnerBlock">
          <ng-container
              *ngTemplateOutlet="categoryDetailsBlock; context: { isDesctop: false }">
          </ng-container>

          <div *ngIf="activeSelectedType" class="product-type-header mb-24 mt-24 tablet-view m-24">
            <ng-container *ngTemplateOutlet="productTypeHeaderTemplate; context: { type: activeSelectedType }"></ng-container>
            <ng-container *ngTemplateOutlet="productTypeSubHeaderTemplate; context: { type: activeSelectedType }"></ng-container>
          </div>

        <div *ngIf="isShowroomCategory" class="showroom-switcher br-32 d-flex align-items-center justify-content-between">
          <span
            class="fw-600 showroom-switcher__item br-32 fz-12 lh-16 cursor-pointer d-flex align-items-center justify-content-center"
            (click)="changeShowroomState(true)"
            [class.showroom-switcher__item-selected]="isShowroomState"
            >{{ 'Title.Showroom' | translate }}</span
          >
          <span
            (click)="changeShowroomState(false)"
            class="fw-600 showroom-switcher__item br-32 fz-12 lh-16 cursor-pointer d-flex align-items-center justify-content-center"
            [class.showroom-switcher__item-selected]="!isShowroomState"
          >
            {{ 'Title.Classic' | translate }}
          </span>
        </div>
      <ng-container *ngIf="isShowroomState && isShowroomCategory; else productDetailsBlock">
          <div class="showroom-image-container w-100 h-100 position-relative">
            <ng-container *ngIf="imageUrl">
              <img *ngIf="imageUrl" class="h-100 showroom__left-content--image" [src]="imageUrl" alt="image" />
              <ng-container *ngFor="let image of overlayImages">
                <img *ngIf="image.url" class="overlay-image showroom__left-content--image" [src]="image.url"
                  alt=“Overlay”>
              </ng-container>
              <ng-container *ngFor="let image of sceneImages">
                <img *ngIf="image.url" class="overlay-image showroom__left-content--image" [src]="image.url"
                  [ngClass]="'z-index-' + image.zIndex?.value" alt="Scene image">
              </ng-container>
            </ng-container>
          </div>
        </ng-container>

        </ng-container>


      </div>


    </div>

    <div class="options-electro__list d-flex flex-column min-h-0 h-100">
      <div #leftContentBLock class="options-electro__column list-block v-scrollbar overlay-y h-100 " [ngClass]="{
            'has-selected-type': activeSelectedType
          }">
          <ng-container
              *ngTemplateOutlet="categoryDetailsBlock; context: { isDesctop: true }">
          </ng-container>

          <div class="mb-16" *ngIf="!activeSelectedType">
            <ng-container *ngFor="let type of layoutProductTypes; let i = index; let first = first">
              <div class="pr-type-card" (click)="setActiveType(type)" [id]="type.id"  
                  [class.active-item]="(activeProduct?.id && type.product?.id === activeProduct?.id) && !isShowroomState">
                <div class="pr-type-card__content">
                  <div class="pr-type-card__preview">
                    <img
                      [src]="type.icon?.url || 'assets/preview-v2.svg'" [alt]="type.icon?.name" />
                  </div>
                  <div class="pr-type-card__info" [class.justify-content-center]="!type.product">
                    <div class="gl-ellipsis-table-wr">
                      <div class="fz-16 lh-24 fw-500 gl-ellipsis-table-item" #typeNameRef [ngbTooltip]="type.name"
                        [container]="'body'" [disableTooltip]="typeNameRef.offsetWidth >= typeNameRef.scrollWidth"
                        triggers="hover touchstart">
                        {{ type.name }}
                      </div>
                    </div>
                    <div class="gl-ellipsis-table-wr" *ngIf="type.product">
                      <div #typeDescription
                        [ngbTooltip]="type.product?.title + ' · ' + (type.product?.fullPrice | customDecimal) + ',-'"
                        [container]="'body'"
                        [disableTooltip]="typeDescription.offsetWidth >= typeDescription.scrollWidth || !type.product"
                        triggers="hover touchstart" class="fz-16 lh-24 gl-ellipsis-table-item text-gray-890">
                        {{ type.product?.title  }}
                         <span *ngIf="showPrices">
                         {{' · ' + (type.product?.fullPrice | customDecimal) + ',-'}}
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="pr-type-card__arrow">
                  <img src="assets/arrow-right.svg" alt="Icon" />
                </div>
              </div>
            </ng-container>
          </div>

          <ng-container *ngIf="activeSelectedType">
            <ng-container
              *ngTemplateOutlet="productTypeTemplate; context: { type: activeSelectedType }"></ng-container>
          </ng-container>
          <ng-container *ngIf="!layoutProductTypes?.length && !loadingTypes">
            <div class="empty-state d-flex flex-column align-items-center justify-content-center h-60">
              <img src="/assets/cube-icon-sm.svg" alt="icon" />
              <p class="mt-16 fz-16 lh-24 fw-500">{{ 'Shared.Title.No_products_in_category' | translate }}</p>
            </div>
          </ng-container>
      </div>
      <div class="footer d-flex" [class.d-none]="activeSelectedType">
        <div class="d-flex w-100 footer__actions" [class.desctop-view]="activeSelectedType">
          <button [class.invisible]="isFirstCategory" (click)="openPrevCategory()"
            class="newest-button button-gray button-next mr-16 fz-16">
            <img src="/assets/new-arrow-left.svg" class="mr-8" alt="Icon" />
            {{ 'Title.Previous' | translate }}
          </button>
          <ng-container *ngIf="!isLastCategory; else completeOptionsButtonBlock">
            <button (click)="openNextCategory()" class="newest-button button-gray button-next fz-16">
              {{ 'Shared.Title.Next_category' | translate }}

              <img src="/assets/new-arrow-left.svg" class="ml-8 rotate-180" alt="Icon" />
            </button>
          </ng-container>

          <ng-template #completeOptionsButtonBlock>
            <button (click)="moveToSummary()" class="newest-button fz-16 button-complete">
              {{ 'Button.Complete_options' | translate }}
              <img src="/assets/arrow-right-col-blue.svg" class="ml-8" alt="Icon" />
            </button>
          </ng-template>
        </div>

        <div class="d-flex footer__actions-mob" *ngIf="activeSelectedType">
          <button
            (click)="closeSelectedProductType()"
            class="newest-button button-gray button-next fz-16 flex-1 back-button"
        >
          <img src="/assets/new-arrow-left.svg" class="mr-8" alt="Icon" />
            {{ 'Button.Options.Back' | translate }}
         </button>
        </div>

        <button class="newest-button summary-btn" *ngIf="!activeSelectedType" (click)="moveToSummary()">
          <img class="mr-8" src="/assets/cart-blue.svg" alt="summary" />
          <span> {{ (inProgressTotalPrice || 0) | customDecimal }},- </span>
        </button>


      </div>
      <ng-template #selectedTypeBackBtn>
        <button (click)="closeSelectedProductType()"
          class="newest-button button-gray button-next fz-16 flex-1 back-button">
          <img src="/assets/new-arrow-left.svg" class="mr-8" alt="Icon" />
          {{ 'Button.Back' | translate }}
        </button>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #standart>
  <span class="showroom__col-gray fz-16 lh-24"> {{ 'Entity.Standard' | translate }} </span>
</ng-template>

<ng-template #wishlistIcon let-product="product">
  <div class="showroom__checked-wrapper">
    <img class="showroom__checked"
      [src]="!product.addedToPackage ? '/assets/checked-circle.svg' : '/assets/package-icon.svg'" alt="Icon" />
  </div>
</ng-template>

<ng-template #noWidhlistIcon let-product="product">
  <div *ngIf="product.addedToPackage" class="showroom__checked-wrapper">
    <img class="showroom__checked" [src]="'/assets/empty-package.svg'" alt="Icon" />
  </div>
</ng-template>

<ng-template #dateTooltip>
  <div class="d-flex flex-column fz-12 lh-16">
    <span>{{ 'Title.Due_date' | translate }}</span>
    <span>{{ activeProductType.dueDate | date: 'dd.MM.yyyy' }}</span>
  </div>
</ng-template>

<ng-template #noSelectedProduct>
  <ng-container *ngIf="noIncludedOptionSelected">
    <div class="options-electro__images d-flex justify-content-center">
      <div class="options-electro__empty-image">
        <div class="options-electro__image-placeholder">
          <img width="160" heigh="160" src="/assets/cancel-icon.svg" alt="icon" />
        </div>
      </div>

      <div class="fz-20 fw-500 lh-24 options-electro__details">
        <div class="ellipsis">{{ 'Title.I_do_not_want' | translate }} {{ activeType?.name }}</div>

        <div class="no-included-info-box mt-12">
          <img src="/assets/info-icon-v3.svg" alt="icon" class="mr-8 mt-4" />
          <span class="word-break">
            <span class="fw-500 lh-24 fz-16">{{ activeType?.name }} </span>
            <span class="fw-400 lh-24 fz-16">{{
              'Description.No_included_option' | translate: { VALUE: activeType?.name }
              }}</span>
          </span>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #productCardTemplate let-products="products" let-type="type">
  <div class="options-electro__products-wr d-flex flex-column">
    <div *ngFor="let product of products; let first = first; let last = last"
      class="cursor-pointer options-electro__product-item" (click)="setActiveDigitalProduct(product, type, $event)"
      [ngClass]="{
          'options-electro__active': product.selected,
          'mt-8': !first
        }">
      <atl-card-container>
        <ng-container ngProjectAs="cc-icon"></ng-container>
        <ng-container ngProjectAs="cc-info">
          <div class="options-electro__icon mr-16 br-8 d-flex justify-content-center align-items-center">
            <img [src]="
                  product.itemType === wishlistItemType.NoStandardDelivery ? '/assets/prohibit-icon.svg' : product.preview
                " alt="icon" class="br-8" />
          </div>
        </ng-container>

        <ng-container ngProjectAs="occ-control">
          <div class="d-inline-flex align-items-center card-tablet">
            <div>
              <div class="gl-ellipsis-table-wr">
                <p #productTitleBlock class="fz-16 lh-24 fw-500 product-title gl-ellipsis-table-item"
                  [ngbTooltip]="product.title" [container]="'body'"
                  [disableTooltip]="productTitleBlock.offsetWidth >= productTitleBlock.scrollWidth"
                  triggers="hover touchstart">
                  {{ product.title }}
                </p>
              </div>
              <ng-container *ngIf="product.id">
                <div class="gl-ellipsis-table-wr text-gray-890">
                  <div class="gl-ellipsis-table-item">
                    <span *ngIf="!product.standard && showPrices" class="fz-16 lh-24">
                      {{
                      product.fullPrice !== 0
                      ? ('Shared.Entity.Option' | translate) + ' · ' + (product.fullPrice | customDecimal) + ',-'
                      : ('Title.Cost_free_option' | translate) + ' · 0,-'
                      }}
                    </span>
                    <span *ngIf="product.standard" class="fz-16 lh-24">{{ 'Shared.Entity.Standart' | translate }}
                      <ng-container *ngIf="showPrices">
                        · {{ product.fullPrice | customDecimal }},-
                      </ng-container>
                    </span>

                  </div>
                </div>
              </ng-container>
            </div>

            <div
              class="product-details-icon"
              *ngIf="isShowroomState && isShowroomCategory && product.id"
              (click)="openProductDetailsModal($event, product, type)"
         >
            <img src="/assets/info-icon-black.svg" alt="details" />
           </div>

            <ng-container *ngIf="!product?.selected; else selectedBtn">
              <div class="selection-buttons">
                <button class="newest-button" (click)="setActiveDigitalProduct(product, type, $event)">
                  {{ 'Shared.Title.Select' | translate }}
                </button>
              </div>
            </ng-container>

            <ng-template #selectedBtn>
              <button   class="selected-label-button">
                {{ 'Shared.Title.Selected' | translate }}
              </button>
            </ng-template>

          </div>
        </ng-container>
        <ng-container ngProjectAs="cc-freetext">
          <ng-container *ngIf="!product.picarioData && isShowroomState && product.id && isShowroomCategory">
            <div *ngIf="product.itemType !== wishlistItemType.NoStandardDelivery" class="not-support-description fz-16 lh-24 mt-16">
                {{ 'Description.Showroom_not_supported_product_desc' | translate }}
            </div>
          </ng-container>

        </ng-container>
      </atl-card-container>

    </div>
  </div>
</ng-template>

<ng-template #productTypeTemplate let-type="type">
  <div class="d-flex flex-column" [ngClass]="{
        'active-type mt-24 border-bottom back-block': activeSelectedType
      }">
    <div class="options-electro__group d-inline-flex align-items-center cursor-pointer mb-12 desctop-view"
      (click)="closeSelectedProductType()">
      <img class="mr-4 filter-icon-black-960" src="assets/arrow-left-mobile.svg" alt="left-icon" />
      <p class="fz-16 lh-24 fw-500">{{ 'Button.Back' | translate }}</p>
    </div>
    <div class="product-type-header mb-24 mt-4 desctop-view">
      <ng-container *ngTemplateOutlet="productTypeHeaderTemplate; context: { type: type }"></ng-container>
      <ng-container *ngTemplateOutlet="productTypeSubHeaderTemplate; context: { type: type }"></ng-container>
    </div>
  </div>

  <ng-container *ngIf="type.products?.length">
    <ng-container *ngTemplateOutlet="
          productCardTemplate;
          context: { products: type.products, type: type }
        "></ng-container>
  </ng-container>

  <ng-container *ngIf="!selectedGroup; else selectedGroupBlock">
    <div *ngIf="type.grouped" class="mt-24">
      <div
        *ngFor="let group of type.groups; let first = first; let index = index"
        class="cursor-pointer"
        (click)="selectGroup(group)"
        [ngClass]="{
          'options-electro__active': group.isActiveGroup
        }"
      >
        <atl-card-container>
          <ng-container ngProjectAs="cc-info">
            <div class="options-electro__icon mr-16 br-8 d-flex justify-content-center align-items-center">
              <img
               [src]="group.isActiveGroup ? group.preview : '/assets/four-squares-icon.svg'"
                alt="icon"
                class="br-8 object-fit-contain"
                [class.empty-group-icon]="!group.isActiveGroup"
              />
            </div>
          </ng-container>
          <ng-container ngProjectAs="occ-control">
            <div class="w-100">
              <div
                class="fz-16 lh-24 fw-500 d-inline-flex gl-ellipsis-table-wr"
                [ngbTooltip]="group.name"
                [disableTooltip]="groupName.offsetWidth >= groupName.scrollWidth"
                triggers="hover touchstart"
              >
                <span #groupName class="gl-ellipsis-table-item group-title">
                  {{ group.name }}
                </span>
              </div>

              <ng-container *ngIf="group.isActiveGroup; else nonActiveGroupCounter">
                <div class="gl-ellipsis-table-wr">
                  <p
                    *ngIf="group.productTitle"
                    class="fz-16 lh-24 d-inline-flex gl-ellipsis-table-item text-gray-890"
                  >
                    {{ group.productTitle }}
                  </p>
                </div>
              </ng-container>
              <ng-template #nonActiveGroupCounter>
                <p class="fz-16 lh-24 text-gray-890">
                  {{ group.products.length }} {{ 'Shared.Title.Options' | translate }}
                </p>
              </ng-template>
            </div>
          </ng-container>
          <ng-container ngProjectAs="occ-control">
            <div class="d-flex w-100 justify-content-end">
              <ng-container *ngIf="group.isActiveGroup">
                  <button class="selected-label-button mr-16">
                    {{
                      'Shared.Button.Selected' | translate
                    }}
                  </button>
              </ng-container>
              <img src="assets/arrow-right.svg" alt="Icon" />
            </div>
          </ng-container>
        </atl-card-container>
      </div>
    </div>
  </ng-container>

  <ng-template #selectedGroupBlock>
      <ng-container
        *ngTemplateOutlet="productCardTemplate; context: { products: selectedGroup.products, type: activeSelectedType }"
      ></ng-container>
  </ng-template>
</ng-template>

<ng-template #productTypeHeaderTemplate let-type="type">
  <h3 *ngIf="type.products?.length || type.groups?.length" class="fw-500 lh-24 fz-20 d-flex justify-content-between w-100"
    [class.active-type]="activeSelectedType">
    <div *ngIf="!selectedGroup; else selectedGroupTitle" class="d-inline-flex align-items-center justify-content-between w-100 white-space-nowrap">
      <div class="type-name w-fit-content fw-600 fz-24 lh-24" #typeName>
        <span class="ellipsis" #typeNameRef [ngbTooltip]="type.name" [container]="'body'" class="lh-28"
          [disableTooltip]="typeNameRef.offsetWidth >= typeNameRef.scrollWidth" triggers="hover touchstart">
          {{ type.name }}
        </span>

        <span *ngIf="type.grouped" class="d-inline-flex align-items-center ml-8 mr-8">
          <span class="fz-16 fw-500 mr-4">
            {{ 'Shared.Title.Groups' | translate }}
          </span>
          <img
            src="/assets/info-icon-new.svg"
            alt="icon"
            [ngbTooltip]="'Shared.Title.Groups_description' | translate"
            [container]="'body'"
            triggers="hover touchstart"
          />
        </span>
      </div>
    </div>
  </h3>

  <ng-template #selectedGroupTitle>
    <h3 class="fz-24 fw-600 lh-28 ellipsis">{{ selectedGroup.name | truncate: 40 }}</h3>
  </ng-template>
</ng-template>

<ng-template #productTypeSubHeaderTemplate let-type="type">
  <div *ngIf="type.description" class="mt-16">
    <atl-read-more [content]="type.description" [limit]="companyDescriptionLimit" [completeWords]="false">
    </atl-read-more>
  </div>

</ng-template>

<ng-template #categoryDetailsTemplate>
    <div class="options-electro__category-details desctop-view">
      <div *ngIf="categoryDetails.description">
        <atl-read-more *ngIf="categoryDetails.description" [content]="categoryDetails.description"
          [limit]="companyDescriptionLimit" [completeWords]="false">
        </atl-read-more>
      </div>

      <div class="d-inline-flex align-items-center" *ngIf="categoryDetails.dueDate">
        <img class="mr-8" src="/assets/calendar-icon-sm.svg" alt="icon" />
        <span class="fz-16 lh-24">{{ 'Shared.Title.Category_deadline' | translate }}
          <span class="fw-600">{{ categoryDetails.dueDate | date: 'dd.MM.yyyy' }}</span>
        </span>
      </div>

      <div class="d-flex" *ngIf="categoryDetails.contactPerson">
        <div class="options-electro__company-dropdown d-flex justify-content-between w-100">
          <atl-accordion>
            <ng-container ngProjectAs="visible-content"></ng-container>
            <ng-container ngProjectAs="trigger">
              <span class="underline fz-14 lh-24 mr-4">{{ 'Shared.Title.Contact_information' | translate }}</span>
            </ng-container>
            <ng-container ngProjectAs="accordionContent">
              <div class="options-electro__h-16"></div>
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-block text-black-810">
                  <img class="mr-8" src="/assets/house-icon.svg" alt="icon" />
                  <span class="fz-14">{{ 'Shared.Title.Company' | translate }}</span>
                </div>
                <p class="fz-14 lh-24">
                  {{ categoryDetails.contactPerson?.companyTitle }}
                </p>
              </div>

              <div *ngIf="categoryDetails.contactPerson.name"
                class="d-flex align-items-center justify-content-between mt-16">
                <div class="d-block text-black-810">
                  <img class="mr-8" src="/assets/user-icon.svg" alt="icon" />
                  <span class="fz-14">{{ 'Shared.Title.Person' | translate }}</span>
                </div>

                <p class="fz-14 lh-24">
                  {{ categoryDetails.contactPerson?.name }}
                </p>
              </div>

              <div *ngIf="categoryDetails.contactPerson?.phone"
                class="d-flex align-items-center justify-content-between mt-16">
                <div class="d-block text-black-810">
                  <img class="mr-8" src="/assets/phone-icon.svg" alt="icon" />
                  <span class="fz-14">{{ 'Client.Newest_Task_Modal.Phone' | translate }}</span>
                </div>

                <a [attr.href]="'tel:' + categoryDetails.contactPerson?.phone"
                  class="options-electro__col-primary fz-14 lh-24">{{ categoryDetails.contactPerson?.phone }}</a>
              </div>

              <div class="d-flex align-items-center justify-content-between mt-16 email-wrapper">
                <div class="d-inline-flex align-items-center text-black-810 white-space-nowrap">
                  <img class="mr-8" src="/assets/envelope-icon.svg" alt="icon" />
                  <span class="fz-14 mr-8">{{ 'Shared.Title.Email' | translate }}</span>
                </div>
                <a [href]="'mailto:' + categoryDetails.contactPerson?.email"
                  class="options-electro__col-primary fz-14 lh-24 ellipsis">
                  {{ categoryDetails.contactPerson?.email }}
                </a>
              </div>
            </ng-container>
          </atl-accordion>
        </div>
      </div>
    </div>


</ng-template>

<ng-template #productDetailsBlock>
  <ng-container *ngIf="!loadingProduct; else spinnerBLock">
    <div *ngIf="activeProduct; else noActiveProduct" class="options-electro__images d-flex position-relative justify-content-center"
      [class.mt-80]="isShowroomCategory">
      <div
        class="options-electro__left-wrapper"
        [class.multiple]="activeProduct?.imagesAttributes && activeProduct.imagesAttributes.length > 1"
      >
        <div class="options-electro__images-wrapper">
            <atl-image-slider
              *ngIf="activeProduct?.imagesAttributes?.length; else emptyImages"
              #atlImageSliderComponent
              [images]="activeProduct.imagesAttributes"
              [config]="imageSliderSwiperOptions"
              (afterInitSwiper)="afterInitSwiperHandler()"
            >
              <ng-container ngProjectAs="footer">
                <atl-slider-gallery-view
                  class="element--hidden p-16"
                  [images]="activeProduct.imagesAttributes"
                  [activeIndex]="atlImageSliderComponent.swiperInstance?.realIndex || 0"
                  [swiperInstance]="atlImageSliderComponent.afterInitSwiper | async"
                />
              </ng-container>
            </atl-image-slider>
          <ng-template #emptyImages>
            <div class="h-100 w-100">
              <div class="options-electro__image-placeholder">
                <img src="/assets/empty-image-icon.svg" alt="icon" />
              </div>
            </div>
          </ng-template>
        </div>

        <div class="mt-24 pb-24 options-electro__product-files" *ngIf="activeProduct?.fileResourcesAttributes?.length">
          <p class="fz-16 lh-24 fw-500">{{ 'Title.Attachments' | translate }}</p>
          <div class="d-flex flex-wrap">
            <atl-newest-document-card
              *ngFor="let document of activeProduct?.fileResourcesAttributes; index as i"
              class="options__download-card mr-8 mt-8"
              [hasRemove]="false"
              (click)="onPreviewDocument(i)"
              [fileName]="document.name | truncate: fileNameLimit"
              [fileSize]="document.fileSize"
              [fileType]="document.fileExtension"
              [downloadLink]="document.fileName?.downloadUrl"
            >
            </atl-newest-document-card>
          </div>
        </div>
      </div>

      <div class="options-electro__details">
        <div class="d-flex flex-row justify-content-between">
          <div class="d-flex flex-column">
            <h2 class="fz-20 lh-24 fw-500 word-break">{{ activeProduct.title }}</h2>
            <h3 *ngIf="activeProduct.productProducer" class="fz-16 lh-24 text-gray-890 mt-8">
              {{ activeProduct.productProducer.name }}
            </h3>
            <div 
              class="d-flex word-break lh-24 fz-16 f-family-sfpro mobile-text"
              [class.mt-12]="!activeProduct.productProducer"
            >
              <atl-shadow-dom-content>
                <div class="fz-16 lh-24 word-break" [innerHTML]="activeProduct.description"></div>
              </atl-shadow-dom-content>
            </div>
          </div>
        </div>

        <div class="mt-24 tablet-content" *ngIf="activeProduct?.fileResourcesAttributes?.length">
          <p class="fz-16 lh-24 fw-500">{{ 'Title.Attachments' | translate }}</p>
          <div class="d-flex flex-wrap">
            <atl-newest-document-card
              *ngFor="let document of activeProduct?.fileResourcesAttributes; index as i"
              class="option__download-card mt-8 mr-8"
              [hasRemove]="false"
              (click)="onPreviewDocument(i)"
              [fileName]="document.name | truncate: fileNameLimit"
              [fileSize]="document.fileSize"
              [fileType]="document.fileExtension"
              [downloadLink]="document.fileName?.downloadUrl"
            >
            </atl-newest-document-card>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <ng-template #noActiveProduct>
      <ng-container class="isNoStandardProduct">
        <div class="options-electro__images d-flex justify-content-center" [class.mt-80]="isShowroomCategory">
          <div class="options-electro__empty-image">
            <div class="options-electro__image-placeholder">
              <img width="160" heigh="160" src="/assets/cancel-icon.svg" alt="icon" />
            </div>
          </div>

          <div class="fz-20 fw-500 lh-24 options-electro__details">
            <div class="ellipsis">
              <span *ngIf="activeSelectedType?.name">{{ 'Title.I_do_not_want' | translate }}</span>
               {{ activeSelectedType?.name || layoutProductTypes[0]?.products[0]?.title }}</div>
            <div class="no-included-info-box mt-12">
              <img src="/assets/info-icon-v3.svg" alt="icon" class="mr-8 mt-4" />
              <span class="word-break">
                <span class="fw-500 lh-24 fz-16">{{ activeSelectedType?.name || layoutProductTypes[0]?.products[0]?.title }} </span>
                <span class="fw-400 lh-24 fz-16">{{
                  'Description.No_included_option' | translate: { VALUE: activeSelectedType?.name || layoutProductTypes[0]?.products[0]?.title }
                }}</span>
              </span>
            </div>
          </div>
        </div>
      </ng-container>
  </ng-template>
</ng-template>

<ng-template #categoryDetailsBlock let-isDesctop="isDesctop">
  <ng-container *ngIf="categoryDetails">
    <div class="options-electro__category-details-wr"
      [ngClass]="{ 'desctop-view': isDesctop, 'tablet-view': !isDesctop }"
      *ngIf="categoryDetails && !activeSelectedType">
      <div *ngIf="categoryDetails && !activeSelectedType"
        class="options-electro__category-details">
        <div class="d-flex align-items-center justify-content-between">
          <h2 class="fz-24 lh-32 fw-600 options-electro__category-name word-break d-block ellipsis">
            {{ categoryDetails.name }}
          </h2>
        </div>

        <div *ngIf="categoryDetails.description && !loadingTypes">
          <atl-read-more [content]="categoryDetails.description" [limit]="companyDescriptionLimit"
            [completeWords]="false">
          </atl-read-more>
        </div>

        <div class="d-inline-flex align-items-center" *ngIf="categoryDetails.dueDate">
          <img class="mr-8" src="/assets/calendar-icon-sm.svg" alt="icon" />
          <span class="fz-16 lh-24">{{ 'Shared.Title.Category_deadline' | translate }}
            <span class="fw-600">{{ categoryDetails.dueDate | date: 'dd.MM.yyyy' }}</span>
          </span>
        </div>

        <div class="d-flex" *ngIf="categoryDetails.contactPerson">
          <div class="options-electro__company-dropdown d-flex justify-content-between w-100">
            <atl-accordion class="w-100">
              <ng-container ngProjectAs="visible-content"></ng-container>
              <ng-container ngProjectAs="trigger">
                <span class="underline fz-14 lh-24 mr-4">{{
                  'Shared.Title.Contact_information' | translate
                  }}</span>
              </ng-container>
              <ng-container ngProjectAs="accordionContent">
                <div class="options-electro__h-16"></div>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-block text-black-810">
                    <img class="mr-8" src="/assets/house-icon.svg" alt="icon" />
                    <span class="fz-14">{{ 'Shared.Title.Company' | translate }}</span>
                  </div>
                  <p class="fz-14 lh-24">
                    {{ categoryDetails.contactPerson?.companyTitle }}
                  </p>
                </div>

                <div *ngIf="categoryDetails.contactPerson.name"
                  class="d-flex align-items-center justify-content-between mt-16">
                  <div class="d-block text-black-810">
                    <img class="mr-8" src="/assets/user-icon.svg" alt="icon" />
                    <span class="fz-14">{{ 'Shared.Title.Person' | translate }}</span>
                  </div>

                  <p class="fz-14 lh-24">
                    {{ categoryDetails.contactPerson?.name }}
                  </p>
                </div>

                <div *ngIf="categoryDetails.contactPerson?.phone"
                  class="d-flex align-items-center justify-content-between mt-16">
                  <div class="d-block text-black-810">
                    <img class="mr-8" src="/assets/phone-icon.svg" alt="icon" />
                    <span class="fz-14">{{ 'Client.Newest_Task_Modal.Phone' | translate }}</span>
                  </div>

                  <a [attr.href]="'tel:' + categoryDetails.contactPerson?.phone"
                    class="options-electro__col-primary fz-14 lh-24">{{ categoryDetails.contactPerson?.phone
                    }}</a>
                </div>

                <div class="d-flex align-items-center justify-content-between mt-16 email-wrapper">
                  <div class="d-inline-flex align-items-center text-black-810 white-space-nowrap">
                    <img class="mr-8" src="/assets/envelope-icon.svg" alt="icon" />
                    <span class="fz-14 mr-8">{{ 'Shared.Title.Email' | translate }}</span>
                  </div>
                  <a [href]="'mailto:' + categoryDetails.contactPerson?.email"
                    class="options-electro__col-primary fz-14 lh-24 ellipsis">
                    {{ categoryDetails.contactPerson?.email }}
                  </a>
                </div>
              </ng-container>
            </atl-accordion>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!activeSelectedType" class="options-electro__category-reset d-flex justify-content-between"
        [ngClass]="{ 'desctop-view': isDesctop, 'tablet-view': !isDesctop }">
      <div class="d-flex flex-column">
        <div class="fz-12 lh-16 text-gray-890">{{ 'Shared.Options.Category_total' | translate }}</div>
        <div class="fz-16 lh-24 fw-500">{{ (this.activeCategoryData?.totalPrice || 0) | customDecimal }},-</div>
      </div>
      <button *ngIf="showResetButton" class="newest-button newest-button--outline" (click)="resetCategory()">
        <img src="/assets/reset-icon.svg" alt="reset" class="filter-icon-black-960 mr-8">
        {{ 'Shared.Options.Reset_selection' | translate }}
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #spinnerBlock>
  <div class="w-100 h-100">
    <div class="d-flex align-items-center justify-content-center h-90">
      <span class="custom-spinner custom-spinner-32"></span>
    </div>
  </div>
</ng-template>
